
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService  from "../../../service/Api";
import { contentTypeResults,GroupsResponse,PermissionsResponse } from "./types";

export const fetchContentTypes = createAsyncThunk(
  "rolesAndPermissions/fetchContentTypes",
  async () => {
    const res = await apiService.get<contentTypeResults>("/api/authentication/content-type/?page_size=5000");
    return res.data.results;
  }
);

export const fetchGroups = createAsyncThunk(
  "rolesAndPermissions/fetchGroups",
  async () => {
    const res = await apiService.get<GroupsResponse>("/api/authentication/groups/?page_size=50");
    return res.data.results;
  }
);

export const fetchPermissions = createAsyncThunk(
  "rolesAndPermissions/fetchPermissions",
  async () => {
    const res = await apiService.get<PermissionsResponse>("/api/authentication/permissions/?page_size=5000");
    return res.data.permissions;
  }
);
